import React from "react";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 py-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            About Us
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We're dedicated to providing the best helpdesk management solution
            for businesses of all sizes
          </p>
        </div>

        {/* Mission Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gray-800 border border-gray-700 rounded-3xl p-12 shadow-2xl">
            <h2 className="text-3xl font-bold text-white mb-6">Our Mission</h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-4">
              Ichthus Technology was founded in 2013 by a group of IT professionals with 9 years of combined experience. Back then, the team offered purely IT consulting and servicing to local companies. Five years later, the company was officially established, allowing us direct access to hardware distributors, making our service truly end-to-end.


            </p>

          </div>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <ValueCard
            icon={
              <svg
                className="w-12 h-12"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            }
            title="Innovation"
            description="We continuously improve our platform with cutting-edge features and technologies"
          />
          <ValueCard
            icon={
              <svg
                className="w-12 h-12"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            }
            title="Reliability"
            description="Our platform is built with stability and uptime as top priorities"
          />
          <ValueCard
            icon={
              <svg
                className="w-12 h-12"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            }
            title="Customer First"
            description="Every decision we make is guided by what's best for our users"
          />
        </div>

        {/* Team Section */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-12 shadow-2xl text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Our Team</h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-8">
            We're a diverse team of passionate individuals committed to building
            the best helpdesk solution. From developers to support specialists,
            everyone on our team shares the same goal: helping you succeed.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex flex-wrap gap-3 justify-center md:justify-start">
              <span className="px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm md:text-base">
                Real-time Chat
              </span>

              <span className="px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm md:text-base">
                Ticket Management
              </span>

              <span className="px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm md:text-base">
                24/7 Support System
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

const ValueCard = ({ icon, title, description }) => (
  <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8 hover:border-purple-500 transition-all duration-300 transform hover:scale-105">
    <div className="text-blue-400 mb-4">{icon}</div>
    <h3 className="text-2xl font-bold text-white mb-4">{title}</h3>
    <p className="text-gray-400">{description}</p>
  </div>
);

export default About;